// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 96) return "vendors-32232445a33092728907.js";
	// return url for filenames based on template
	return "" + ({"391":"process-details","806":"__federation_expose_routes","870":"process-overview"}[chunkId] || chunkId) + "-" + {"72":"554bb58990d3825521ad","391":"2b35452196b55c09996b","543":"ceae008b0db0d0e5fe97","691":"3f527f134c6a1efa012f","756":"d47dc2e6cee64d652a74","806":"937683eb79e7e583031f","870":"40ec51dc9b709a1592d1"}[chunkId] + ".js";
};